import { render, staticRenderFns } from "./SubFooter.vue?vue&type=template&id=5fe71ac5&scoped=true"
import script from "./SubFooter.vue?vue&type=script&lang=js"
export * from "./SubFooter.vue?vue&type=script&lang=js"
import style0 from "./SubFooter.vue?vue&type=style&index=0&id=5fe71ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe71ac5",
  null
  
)

export default component.exports